import { 
  Component, 
  OnInit,
  OnChanges,
  Input,
  SimpleChanges, 
  EventEmitter,
  Output,
  Inject
} from '@angular/core';

import { FatNumberStyles } from './models/widget';
import { isNil } from 'lodash-es';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { Waves_ShellService } from './Waves.shell.service';
import { Waves_OperationService } from './Waves.operation.service';
import { Waves_DatasourceService } from './Waves.datasource.index';
import { Waves_FlowService } from './Waves.flow.index';
import { Waves_ReportService } from './Waves.report.index';
import { Waves_LocalizationService } from './Waves.localization.service';
import { Waves_order_count_widget_ComponentContextService } from './Waves.order_count_widget.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './Waves.frontend.types'
import { $frontendTypes as $types} from './Waves.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'Waves-order_count_widget',
  templateUrl: './Waves.order_count_widget.component.html'
})
export class Waves_order_count_widgetComponent extends BaseComponent implements OnInit, OnChanges {
  //#region Outputs
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  inParams: { waveId?: number } = { waveId: null };
  //#region Inputs
  @Input('waveId') set $inParams_waveId(v: number) {
    this.inParams.waveId = v;
  }
  get $inParams_waveId(): number {
    return this.inParams.waveId;
  }
  //#endregion Inputs

  //#region Variables
  //#endregion  
  private entity: { ShipmentCount?: number };

  value: any;
  styles: FatNumberStyles;
  originalValue: any;
  prefix: string = '';
  suffix: string = '';

  constructor(private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: Waves_ShellService,
private $datasources: Waves_DatasourceService,
private $flows: Waves_FlowService,
private $reports: Waves_ReportService,
private $localization: Waves_LocalizationService,
private $operations: Waves_OperationService,
private $logger: CleanupLoggerService,
private $context: Waves_order_count_widget_ComponentContextService,
) { 
    super();

    this.styles = new FatNumberStyles();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  initialized = false;
  $hasDataLoaded = false;

  async $init() {

    await this.$dataLoad();

    this.initialized = true;
  }
  
  async $dataLoad() {
    const $widget = this;
    const $utils = this.$utils;

    const dsParams = {
      waveId:  $widget.inParams.waveId 
    };

    const data = await this.$datasources.Waves.ds_order_count_by_wave_widget.get(dsParams);
    if (isNil(data.result)) {
      this.$hasDataLoaded = false;
      this.entity = null;
    } else {
      this.$hasDataLoaded = true;
      this.entity = data.result;
      await this.$dataLoaded();
    }
  }

  async $dataLoaded() {
    const $widget = this;
    const $utils = this.$utils;

    this.value = $widget.entity.ShipmentCount;

    
    this.originalValue = $widget.entity.ShipmentCount;
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  getStyleClass() {
    const valString = isNil(this.value) ? '' : this.value.toString();
    const length = (valString).length;
    if (length === 2) {
      return 'tens';
    }
    if (length === 3) {
      return 'hundreds';
    }
    if (length === 4) {
      return 'thousands';
    }
    if (length === 5) {
      return 'tenThousands';
    }
    if (length === 6) {
      return 'hundredThousands';
    }
    if (length > 6) {
      return 'millions';
    }
    return null;
  }

}
